import { CenterBox, CenterDiv, ContentSpan, GoldenSpan, SectionTitle } from "./compnents"
import contentservice1 from './assets/contentservice1.png'
import videocase1 from './assets/videocase1.png'
import videocase2 from './assets/videocase2.png'
import videocase3 from './assets/videocase3.png'
import videocase4 from './assets/videocase4.png'
import livecase1 from './assets/livecase1.png'
import livecase2 from './assets/livecase2.png'
import agt from './assets/agt.png'
import { PlayCircleOutlined } from '@ant-design/icons'
import styled from "@emotion/styled"

export const ContentService = () => {
    return <div>
        <div style={{ position: 'relative', height: '50rem' }}>
            <SectionTitle top={'9rem'} title={'内容服务'} subTitleLeft={'CONTENT'} subTitleRight={'SERVICES'} />
            <CenterBox style={{ top: '19.4rem', alignItems: 'center', justifyContent: 'space-around', padding: '0 20%', marginTop: '2rem' }}>
                <ContentSpan style={{ width: '42rem' }}>我们始终专注于<GoldenSpan>金融领域</GoldenSpan>，内容服务主要业务包括财经视频内容、产品视频、企业宣传视频制作，直播运营，财经 IP 打造，版权服务，动画和图文制作等。</ContentSpan>
                <img src={contentservice1} alt={'Content Service'} style={{ width: '49.1rem', objectFit: 'cover' }} />
            </CenterBox>
        </div>

        <div style={{ position: 'relative' }}>
            <CenterDiv style={{ marginTop: '13rem', flexDirection: 'column', alignItems: 'center' }}>
                <h2 style={{ marginBottom: '0' }}>视&nbsp;&nbsp;频&nbsp;&nbsp;案&nbsp;&nbsp;例</h2>
                <span style={{ fontSize: '2.6rem' }}><GoldenSpan>CASE</GoldenSpan></span>
            </CenterDiv>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', margin: '5rem 0' }}>
                <div style={{ position: 'relative' }}>
                    <img src={videocase1} alt={'Video Case 1'} style={{ objectFit: 'cover', marginBottom: '2rem' }} />
                    <div style={{ position: 'absolute', left: '40rem', top: '20rem', fontSize: '8.3rem' }}>
                        <PlayLink href={'https://mr.baidu.com/r/wHUEaLsdck?f=cp&u=8a663d1fc826ed14'} target={'_blank'} rel={'noreferrer'}>
                            <PlayCircleOutlined />
                        </PlayLink>
                    </div>
                </div>
                <div style={{ position: 'relative' }}>
                    <img src={videocase2} alt={'Video Case 2'} style={{ objectFit: 'cover', marginBottom: '2rem' }} />
                    <div style={{ position: 'absolute', left: '73rem', top: '20.1rem', fontSize: '8.3rem' }}>
                        <PlayLink href={'https://mr.baidu.com/r/wHV05XFlCM?f=cp&u=1da9d86e03367efd'} target={'_blank'} rel={'noreferrer'}>
                            <PlayCircleOutlined />
                        </PlayLink>
                    </div>
                </div>
                <img src={videocase3} alt={'Video Case 3'} style={{ objectFit: 'cover', marginBottom: '2rem' }} />
                <div style={{ position: 'relative' }}>
                    <img src={videocase4} alt={'Video Case 4'} style={{ objectFit: 'cover' }} />
                    <div style={{ position: 'absolute', left: '70rem', top: '20rem', fontSize: '8.3rem' }}>
                        <PlayLink href={'http://www.djbx.com/art/2021/12/8/art_98_6119.html'} target={'_blank'} rel={'noreferrer'}>
                            <PlayCircleOutlined />
                        </PlayLink>
                    </div>
                </div>
            </div>
        </div>

        <div style={{ position: 'relative' }}>
            <CenterDiv style={{ marginTop: '5rem', flexDirection: 'column', alignItems: 'center' }}>
                <h2 style={{ marginBottom: '0' }}>直&nbsp;&nbsp;播&nbsp;&nbsp;运&nbsp;&nbsp;营&nbsp;&nbsp;案&nbsp;&nbsp;例</h2>
                <span style={{ fontSize: '2.6rem' }}><GoldenSpan>CASE</GoldenSpan></span>
            </CenterDiv>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', margin: '5rem 0' }}>
                <img src={livecase1} alt={'Live Case 1'} style={{ objectFit: 'cover', marginBottom: '2rem' }} />
                <img src={livecase2} alt={'Live Case 2'} style={{ objectFit: 'cover' }} />
            </div>
        </div>

        <div style={{ position: 'relative' }}>
            <CenterDiv style={{ marginTop: '5rem', flexDirection: 'column', alignItems: 'center' }}>
                <h2 style={{ marginBottom: '0' }}>动&nbsp;&nbsp;画、&nbsp;&nbsp;图&nbsp;&nbsp;文&nbsp;&nbsp;案&nbsp;&nbsp;例</h2>
                <span style={{ fontSize: '2.6rem' }}><GoldenSpan>CASE</GoldenSpan></span>
            </CenterDiv>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', margin: '5rem 0' }}>
                <img src={agt} alt={'Animation, graphics and text'} style={{ objectFit: 'cover' }} />
            </div>
        </div>

    </div>
}

const PlayLink = styled.a`
color: white;
`;